import Avatar, { AvatarProps } from "@/shared/data-display/avatar";
import { UserOutlined } from "@ant-design/icons";

export function AvatarView(props: AvatarProps) {
  return <Avatar icon={<UserOutlined />} {...props} />;
}
